export default {
  init() {
    // JavaScript to be fired on all pages


    $('.primary-navigation .insights-menu .sub-menu').prepend('<div class="grid-margin-x grid-x align-middle"><div class="cell large-5 fi-holder"></div><div class="cell large-7"><div class="sm-holder"></div></div></div>');

    $('.primary-navigation .insights-menu .sub-menu li').appendTo('.sm-holder');

    $('.featured-insight-for-nav').prependTo('.fi-holder').show();



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired



    let ebstring = $('.mobile-nav .ebooks-lower .submenu-title').text();
    if(ebstring) {
      let ebnewString = ebstring[0] + ebstring[1].toUpperCase() + ebstring.slice(2).toLowerCase();
      $('.mobile-nav .ebooks-lower .submenu-title').text(ebnewString);
    }

    // console.log(ebnewString);




    $('.mobile-nav-trigger, .mobile-nav-close').click(function(e) {
      e.preventDefault()
      $('.mobile-nav').toggle();
    });

    $('.mobile-nav .menu-item-has-children > a').click(function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next('.sub-menu').toggle();
    });



    $('.primary-navigation .menu-item-has-children > a').click(function(e){
      e.preventDefault();
      if($(this).parent('.menu-item-has-children').hasClass('is-active')){
        $('.primary-navigation .menu-item-has-children').removeClass('is-active');
        $('.primary-navigation .sub-menu').removeClass('active-sub-menu');
      } else {
        $('.primary-navigation .menu-item-has-children').removeClass('is-active');
        $('.primary-navigation .sub-menu').removeClass('active-sub-menu');

        $(this).parent('.menu-item-has-children').addClass('is-active');
        $(this).parent('.menu-item-has-children').children('.sub-menu').addClass('active-sub-menu');
      }



    });

    $(document).click(function(e){
      // if( $(e.target).closest('.sub-menu').length > 0) {
      //   console.log('clicked in nav');
      //   return;
      // }



      // Check if click was triggered on or within menu
      if( $(e.target).closest('.sub-menu').length > 0 || $(e.target).closest('.sm-holder').length > 0 || $(e.target).closest('.primary-navigation li > a').length > 0 ) {
        return;
      }

      // Otherwise
      // trigger your click function
      $('.primary-navigation .menu-item-has-children').removeClass('is-active');
      $('.primary-navigation .sub-menu').removeClass('active-sub-menu');

    });





    $('.nav-callout a').addClass('softbtn');


    /**
     * Get videos on load
     */
    (function () {
      getVideos();
    })();

    /**
     * For each video player, create custom thumbnail or
     * use Youtube max resolution default thumbnail and create
     * iframe video.
     */
    function getVideos() {
      var v = document.getElementsByClassName('youtube-player');
      for (var n = 0; n < v.length; n++) {
        var p = document.createElement('div');


        var placeholder = v[n].hasAttribute('data-thumbnail')
          ? v[n].getAttribute('data-thumbnail')
          : '';

        if (placeholder.length) p.innerHTML = createCustomThumbail(placeholder);


        v[n].appendChild(p);
        p.addEventListener('click', function () {
          var parent = this.parentNode;
          createIframe(parent, parent.getAttribute('data-id'));
        });
      }
    }

    /**
     * Create custom thumbnail from data-attribute provided url
     * @param {string} url
     * @return {string} The HTML containing the <img> tag
     */
    function createCustomThumbail(url) {
      return (
        '<div class="youtube-thumbnail" style="background-image:url(' +
        url +
        ');" ><div class="youtube-play-btn"></div>'
      );
    }



    /**
     * Create and load iframe in Youtube container
     **/
    function createIframe(v, id) {
      var iframe = document.createElement('iframe');
      console.log(v);
      iframe.setAttribute(
        'src',
        '//www.youtube.com/embed/' +
        id +
        '?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0'
      );
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('class', 'youtube-iframe');
      v.firstChild.replaceWith(iframe);
    }

    $('.single-image-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    // Wrap iFrames
    $('[class^="module-"] iframe:not([id^="gform_ajax"])').wrap('<div class="responsive-embed">');






    /* eslint-disable */

    // (function($) {
    //   $(document).on('facetwp-loaded', function() {
    //     var queryString = FWP.build_query_string();
    //     if ( '' === queryString ) { // no facets are selected
    //       $('.facet-reset').hide();
    //       Foundation.reInit($('[data-equalizer]'));
    //     }
    //     else {
    //       // $('html, body').animate({
    //       //   scrollTop: $('.facetwp-template').offset().top - 100
    //       // }, 500);
    //       $('.facet-reset').show();
    //       Foundation.reInit($('[data-equalizer]'));
    //     }
    //   });
    // })(jQuery);


    /* eslint-enable */


    $('.logo-scroller').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 4000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      variableWidth: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode:true,
      pauseOnHover:false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 819,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.logo-grid-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 4,
      rows: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2,
            rows: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $('.logo-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.testimonials-carousel').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
      // adaptiveHeight: true,
    });

    $('.ss-carousel').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
      // adaptiveHeight: true,
    });

    $('.feed-carousel').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
      // adaptiveHeight: true,
    });

    $('.spotlight-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5100,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });


  },
};


$('.module-accordion_twocolumn .tabs-title.is-active .tab-description').show();

$('.module-accordion_twocolumn .tabs-title a').click(function(){
  // Remove state

  $('.module-accordion_twocolumn .tabs-title.is-active .tab-description').slideToggle(200);
  $('.module-accordion_twocolumn .tabs-title.is-active').removeClass('is-active');

  // Active state
  $(this).parent('.tabs-title').addClass('is-active');
  $(this).next('.tab-description').slideToggle(200);
});

// Change gforms buttons to include button classes
$('[id^="gform_submit_button"]').addClass('button primary');

/* eslint-disable */
(function($) {
  $(document).on('facetwp-loaded', function() {
    var queryString = FWP.buildQueryString();
    if ( '' === queryString ) { // no facets are selected
      $('.reset-filters').hide();
    }
    else {
      $('.reset-filters').show();
    }
  });
})(jQuery);



// Function to get URL parameter by name
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



/* eslint-enable */



$('.toggle-tabs-menu').click(function(e){
  e.preventDefault();
  $(this).next('.menu').toggleClass('active').slideToggle(function(){
    if ($(this).is(':visible'))
      $(this).css('display','flex');
  });
});

$('.tabs-nav .menu a').click(function(){
  var title = $(this).text();
  console.log(title);
  $('.toggle-tabs-menu').text(title);
  $('.tabs-nav .menu.active').removeClass('active').toggle();

});







// WEBPACK FOOTER //
// ./scripts/routes/common.js